/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.equipment.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('ResourcesEquipmentController', ['$scope', '$uibModal', 'ApiService', 'HelpersService', function($scope, $uibModal, ApiService, HelpersService) {

    $scope.gridLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })">{{row.getProperty(col.field)}}</a></div>';

    $scope.resourcesEquipment = {

      addModal: {},
      currentEquipment: {},

      model: [],
      selected: [],

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Equipment Manager',
          buttonRight: {
            label: '+ Add Equipment',
            action: function() {
              $scope.resourcesEquipment.addEquipment();
            }
          }
        });
        this.getEquipment();
      },

      create: function() {
        if (this.currentEquipment.hasOwnProperty('name') && this.currentEquipment.name.length > 0) {
          ApiService.resource.equipment.create(this.currentEquipment).then(this.success.create, this.error.create);
        }
      },

      remove: function() {
        var i, ii = this.selected.length;

        if (ii > 0) {
          for (i=0;i<ii;i++) {
            ApiService.resource.equipment.remove(this.selected[i].id).then(this.success.remove, this.error.remove);
          }
        }

      },

      hasSelected: function() {
        return (this.selected.length > 0);
      },

      hasEquipment: function() {
        return (this.model.length > 0);
      },

      getEquipment: function() {
        console.log('ResourcesEquipmentController::getEquipment');
        ApiService.resource.equipment.list().then(this.success.getEquipment, this.error.getEquipment);
      },

      addEquipment: function() {

        var self = $scope.resourcesEquipment;

        self.addModal = $uibModal.open({
          templateUrl: 'common/includes/createEquipmentModal.tpl.html',
          controller: ['$scope', '$uibModalInstance', 'ValidateService', 'NoticeFactory', function ($scope, $uibModalInstance, ValidateService, NoticeFactory) {

            $scope.isSubmitted = false;

            // Populate possible values to the model for use in modal
            $scope.model = {
              name: '',
              description: ''
            };

            $scope.errors = [];

            $scope.isValidName = function() {
              var r = true;
              if ($scope.isSubmitted) {
                r = ValidateService.validate([
                  { len: { value: $scope.model.name } }
                ]);
              }

              return r;
            };

            $scope.isValidDescription = function() {
              var r = true;
              if ($scope.isSubmitted) {
                r = ValidateService.validate([
                  { len: { value: $scope.model.description } }
                ]);
              }
              return r;

            };

            $scope.hasErrors = function () {
              return ($scope.errors.length > 0);
            };

            $scope.done = function () {

              $scope.isSubmitted = true;
              if (ValidateService.validate([
                { len: { value: $scope.model.name } },
                { len: { value: $scope.model.description } }
              ])) {
                $scope.success($scope.model);
              }else{
                $scope.errors = [{
                  message: 'Please correct the errors below'
                }];
              }
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function (response) {
              $uibModalInstance.close(response);
            };

          }]
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (equipment) {

          self.currentEquipment = equipment;
          self.create();

        }, function () {
          // Do nothing
        });
      },

      success: {
        create: function(response) {
          $scope.resourcesEquipment.currentEquipment.id = response.data.payload;
          $scope.resourcesEquipment.model.push($scope.resourcesEquipment.currentEquipment);
          $scope.resourcesEquipment.currentEquipment = {};
        },

        getEquipment: function(response) {
          $scope.resourcesEquipment.model = response.data.payload;
        },

        remove: function(response) {
          var i, ii,
            j, jj;

          for (i=0,ii=$scope.resourcesEquipment.selected.length;i<ii;i++) {
            for (j=0,jj=$scope.resourcesEquipment.model.length;j<jj;j++) {
              if ($scope.resourcesEquipment.selected[i].id === $scope.resourcesEquipment.model[j].id) {
                $scope.resourcesEquipment.model.splice(j, 1);
              }
            }
          }

          $scope.unassignedEquipmentGridOptions.selectAll(false);

        }
      },

      error: {
        create: function(response) {
          // TODO: Need to implement
        },

        getEquipment: function(response) {
          // TODO: Need to implement
        },

        remove: function(response) {}

      }


    };

    $scope.unassignedEquipmentGridOptions = {
      paginate: false,
      enableRowSelection: true,
      multiselect: true,
      columnDefs: [
        {
          field: 'name',
          displayName: 'Name'
        },
        {
          field: 'description',
          displayName: 'Description'
        }
      ]
    };

    $scope.resourcesEquipment.init();

}]);